<template>
  <ul class="image_list">
    <li class="image_item" :key="item.linkid" v-for="(item, index) in imageList">
      <UploadImage
        :imageWidth="imageWidth"
        :imageHeight="imageHeight"
        :imageSize="imageSize"
        :originImageUrl="item.imageUrl"
        :imageId="item.linkid"
        v-on:upload-result="onUploadResult"
      ></UploadImage>
      <el-input v-if="inputModelName" placeholder="请输入内容" v-model="item.inputModelName">
        <template slot="prepend">{{inputTitle}}:</template>
      </el-input>
      <div class="image_btns">
        <el-link type="primary" icon="el-icon-edit" @click="onUpdate(item.linkid, index)">{{submitBtnText}}</el-link>
        <el-link icon="el-icon-delete" @click="onDeletPhoto(item.linkid, index)">{{deleteBtnText}}</el-link>
      </div>
    </li>

    <li class="image_item" v-if="imageList.length < maxImageNum">
      <UploadImage
        ref="addImageComp"
        :imageWidth="imageWidth"
        :imageHeight="imageHeight"
        :imageSize="imageSize"
        :imageId="addedImageId"
        v-on:upload-result="onAddImageUploadResult"
      ></UploadImage>
      <el-input v-if="inputModelName" placeholder="请输入内容" v-model="addImageInput">
        <template slot="prepend">{{inputTitle}}:</template>
      </el-input>
      <el-link type="primary" v-if="addImageUrl" icon="el-icon-edit" @click="onSaveAddedImage()">保存</el-link>
    </li>
  </ul>
</template>

<script>
import UploadImage from './uploadImage'
import { savePublisher, queryActionList2, deleteActionRow, updatPublisher } from '@/api/sysinfo'
import { showGlobalLoading, hideGlobalLoading, toastSuccess, toastError, showConfirm, toastInfo } from '@/common/utils/ui'
export default {
  name: 'ImageList',
  props: {
    imageType: {
      type: [Number, String],
      default: ''
    },
    // 图片宽度
    imageWidth: {
      type: [Number, String],
      default: 200
    },
    // 图片高度
    imageHeight: {
      type: [Number, String],
      default: 200
    },
    // 图片大小,单位是M
    imageSize: {
      type: Number,
      default: 2
    },
    // 最大图片个数
    maxImageNum: {
      type: Number,
      required: true
    },

    submitBtnText: {
      type: String,
      default: '保存'
    },

    deleteBtnText: {
      type: String,
      default: '删除'
    },

    inputModelName: {
      type: String
    },

    imageDescribes: {
      type: String
    },

    inputTitle: {
      type: String
    }
  },
  data () {
    return {
      imageList: [],
      addImageUrl: '', // 添加的图片链接
      addedImageId: 1000,
      addImageInput: ''
    }
  },
  created () {
    this.queryImageList()
  },
  methods: {
    queryImageList () {
      const param = {
        position: this.imageType,
        currentIndex: 1
      }

      queryActionList2(param).then(ret => {
        const data = ret.data || {}
        const list = data.list || []
        list.forEach((item, index) => {
          if (this.inputModelName) {
            item.inputModelName = item[this.inputModelName]
          }
        })
        this.imageList = list
      }).catch(err => {
        console.error(err)
        this.imageList = []
      })
    },
    onUpdate (photoId, index) {
      showConfirm('确定要修改吗?').then(instace => {
        const updteItem = this.imageList[index]
        const param = {
          position: this.imageType,
          imageUrl: updteItem.imageUrl,
          columnIndex: 0, // 固定0
          describes: '照片墙',
          linkid: updteItem.linkid
        }

        if (!updteItem.imageUrl) {
          toastError('请先选择图片')
          return
        }

        if (this.inputModelName) {
          if (!updteItem['inputModelName']) {
            toastError('请先填写内容')
            return
          }
          param[this.inputModelName] = updteItem['inputModelName']
        }
        showGlobalLoading()
        updatPublisher(param).then(ret => {
          if (ret.code === '200') {
            toastSuccess('修改成功')
          } else {
            toastError('图片修改失败,请稍后再试')
          }
          hideGlobalLoading()
        }).catch(err => {
          console.error(err)
          toastError('图片删除失败,请稍后再试')
          hideGlobalLoading()
        })
      })
    },

    onDisableUpdate () {
      toastInfo('请先点击照片选择需要修改后的图片')
    },

    // 删除照片
    onDeletPhoto (photoId, index) {
      showConfirm('确定要删除该图片吗?').then(instace => {
        const param = {
          position: this.imageType,
          // imageUrl: this.imageUrl,
          columnIndex: 0, // 固定0
          describes: this.imageDescribes,
          linkId: photoId
        }
        showGlobalLoading()
        deleteActionRow(param).then(ret => {
          if (ret.code === '200') {
            toastSuccess('删除成功')
            this.imageList.splice(index, 1)
          } else {
            toastError('图片删除失败,请稍后再试')
          }
          hideGlobalLoading()
        }).catch(err => {
          console.error(err)
          toastError('图片删除失败,请稍后再试')
          hideGlobalLoading()
        })
      })
    },

    onUploadResult (imageUrl, imageId) {
      const ret = this.imageList.filter(item => {
        return item.linkid === imageId
      })[0]

      if (!ret) {
        return
      }
      ret.imageUrl = imageUrl
    },

    onAddImageUploadResult (imageUrl) {
      this.addImageUrl = imageUrl
    },

    // 保存添加的图片
    onSaveAddedImage () {
      if (!this.addImageUrl) {
        return toastError('请选择图片')
      }

      const param = {
        position: this.imageType,
        imageUrl: this.addImageUrl,
        columnIndex: 0, // 固定0
        describes: this.imageDescribes
      }

      if (this.inputModelName) {
        param[this.inputModelName] = this.addImageInput
      }

      showGlobalLoading()
      savePublisher(param).then((ret) => {
        if (ret.code === '200') {
          toastSuccess('保存成功')
          
          const photoItem = this.imageList[this.imageList.length - 1]
          const newItem = {
            linkid: ret.data || photoItem.linkid + 1,
            position: this.imageType,
            imageUrl: this.addImageUrl
          }

          if (this.inputModelName) {
            newItem[this.inputModelName] = this.addImageInput
            newItem['inputModelName'] = this.addImageInput
          }

          this.imageList.push(newItem)

          this.addImageUrl = ''

          this.$refs.addImageComp.imageUrl = ''
        } else {
          toastError('保存失败,请稍后再试')
        }
        hideGlobalLoading()
      }).catch(err => {
        console.error(err)
        hideGlobalLoading()
      })
    },

    onCancelAdd () {
      this.addImageUrl = ''
    }
  },
  components: {
    UploadImage
  }
}
</script>

<style lang="scss" scoped>
  .image_list {
    margin-top: 20px;
  }
  .image_item {
    display: inline-block;
    margin: 10px;
  }
  .image_btns {
    margin-top: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/SysManager/ExhibitionInfo/HomeSetup/components/imageList.vue